/**
 * Show the keywords assigned to a case in nice bubbles.
 *
 * @providesModule KeywordsDisplay
 * 
 */

import * as React from 'react'
import styled from 'styled-components'


function categoryQueryPath (name) {
  return `/catalog/search?tags[]=${name}`
}

const KeywordsDisplay = ({ tags }) => (
  <>
    <div>
      {tags
        .filter(tag => tag.category)
        .map(({ name, displayName }) => (
          <CategoryTag
            key={name}
            category={name}
            label={displayName}
            href={categoryQueryPath(name)}
          />
        ))}
    </div>

    <div className="bp6-dark">
      {tags
        .filter(tag => !tag.category)
        .map(({ name, displayName }) => (
          <KeywordTag key={name} href={categoryQueryPath(name)}>
            {displayName}
          </KeywordTag>
        ))}
    </div>
  </>
)

export default KeywordsDisplay

const CategoryTag = styled.a.attrs({ className: 'bp6-tag bp6-large' })`
  background-image: url(${p => require(`images/category-${p.category}.jpg`)});
  background-position: center;
  background-size: cover;
  font-size: 120% !important;
  font-weight: 600;
  margin: 0 0.5em 0.5em 0;
  text-shadow: 0 0 6px rgba(0,0,0,0.50);
  padding: 0.5em 1em !important;

  &::before {
    content: '${p => p.label}';
    text-transform: capitalize;
  }

  &:hover {
    color: white;
  }
`

const KeywordTag = styled.a.attrs({ className: 'bp6-tag' })`
  margin: 0 0.5em 0.5em 0;
  text-transform: capitalize;

  /* Match the edit-mode chips: light gray fill + dark navy text. As a link inside
     bp6-dark this would otherwise pick up BP6's dark-tag gray fill and the
     .bp6-dark a purple text — !important beats both (as the hover rule already does). */
  background-color: rgb(196, 200, 202) !important;
  color: rgb(1, 24, 45) !important;

  &:hover {
    color: black !important;
  }
`
